import * as React from 'react';

export const GroupLogoPlaceholderIconWide: React.FC = props => (
  <svg viewBox="0 0 131 75" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M-213-640h1366v902H-213z" />
      <path fill="#FFF" stroke="#D6D6D6" d="M-19.5-559.5h979v770h-979z" />
      <path fill="#CCC" d="M0 75h131V0H0z" />
      <path
        fill="#DBDADA"
        d="M90.86 52.73a14.881 14.881 0 0 0-10.501-10.376h.01c2.223-1.221 3.826-3.439 4.154-6.056h.368c.846 0 1.657-.5 1.916-1.306a1.897 1.897 0 0 0-.286-1.75v-3.608c0-5.01-3.438-9.538-8.366-10.448-6.161-1.138-11.589 3.614-11.589 9.574v4.482a1.899 1.899 0 0 0-.286 1.747c.258.807 1.07 1.309 1.918 1.309h.368a7.906 7.906 0 0 0 1.045 3.03h-7.282a7.89 7.89 0 0 0 1.047-3.03h.369c.845 0 1.657-.5 1.915-1.306a1.894 1.894 0 0 0-.286-1.75v-3.608c0-5.01-3.438-9.538-8.366-10.448-6.161-1.138-11.589 3.614-11.589 9.574v4.482a1.899 1.899 0 0 0-.287 1.747c.259.807 1.071 1.309 1.919 1.309h.367c.327 2.618 1.932 4.84 4.156 6.058A14.881 14.881 0 0 0 41.08 52.73c-.396 1.423.714 2.827 2.192 2.827h45.396c1.476 0 2.586-1.404 2.19-2.827"
      />
      <path
        fill="#E5E5E5"
        d="M62.013 44.687c-6.016 1.208-11.044 5.116-13.788 10.403-.876 1.69.323 3.712 2.225 3.712h31.04c1.903 0 3.101-2.022 2.226-3.712-2.745-5.287-7.773-9.195-13.787-10.403"
      />
      <path
        fill="#E5E5E5"
        d="M77.824 32.9v-4.798C77.824 21.446 72.372 16 65.707 16c-6.375 0-11.59 5.208-11.59 11.576V32.9a2.26 2.26 0 0 0-.456 1.351 2.287 2.287 0 0 0 2.28 2.28h.55c.589 4.707 4.614 8.387 9.48 8.387 4.864 0 8.89-3.68 9.479-8.388H76a2.287 2.287 0 0 0 2.28-2.279c0-.506-.173-.97-.456-1.351"
      />
    </g>
  </svg>
);
